<template>
  <div class="footer">
      <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
$background-1: rgba(61, 143, 238);
$background-2: rgba(124, 184, 255);
.footer{
   display: flex;
  justify-content: center;
  align-items: center;
  background-color: $background-1;
  width: 100%;
  height: 80px;
}
</style>